export default __webpack_public_path__ + "static/media/19t.753fdeb5.jpg";